const details = {
    name: "شهر درب",
    enName: "shahr darb",
    description: "بزرگترین تولیدکننده و فروشنده درب در کرج",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: " شرکت برنامه نویسی باران",
        link: "https://barantm.ir"
    }
}

export default details;
